<h3 mat-dialog-title>
  <div class="modal-header">
    <img src="./../assets/images/logos/accept-logo.png" height="40px" alt="Logo">
    <span class="fx-spacer"></span>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</h3>

<mat-dialog-content>
  <ng-container *ngFor="let item of demandResponseInfo">
    <div class="d-flex">
      <h4 class="weight-500">{{ item.label | translate }}</h4>
      <h4 class="ml-auto">{{ item.value }}</h4>
    </div>
  </ng-container>
  <div class="col-12 border border-grey">
    <div class="row p-3 align-items-center">
      <mat-icon class="text-green mr-1">message</mat-icon>
      <h4 class="mb-0 weight-500">{{ 'app.status' | translate }}</h4>
    </div>
    <h5>{{ data.status }}</h5>
  </div>
  <div id="demandProfiles"></div>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-center">
  <div class="close-button">
    <button class="btn bg-green text-white" (click)="close()">{{ 'app.ok' | translate }}</button>
  </div>
</mat-dialog-actions>